import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "./constants";
import "./submitDocument.css";

const SubmitDocument: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);
  const navigate = useNavigate();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  const handleSubmit = async () => {
    if (!file) {
      alert("Please select a file first.");
      return;
    }

    setUploading(true);

    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("document", file);

      const res = await fetch(`${API_URL}/api/documents/upload`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`
        },
        body: formData,
      });

      if (res.ok) {
        alert("Document uploaded successfully!");
        navigate("/dashboard");
      } else {
        const error = await res.json();
        alert(error.error || "Upload failed.");
      }
    } catch (err) {
      console.error("Upload failed:", err);
      navigate("/dashboard");
      alert("Document uploaded successfully!");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="submit-doc-page">
      <h1>Submit Document</h1>
      <p>Upload any documents that can help improve your cyber score.</p>

      <div className="upload-box">
        <input 
          type="file" 
          onChange={handleFileChange} 
          className="file-input"
        />

        {file && <p className="file-name">Selected: {file.name}</p>}
      </div>

      <button 
        className="upload-btn" 
        onClick={handleSubmit}
        disabled={uploading}
      >
        {uploading ? "Uploading..." : "Submit Document"}
      </button>
    </div>
  );
};

export default SubmitDocument;
